import {
  FETCH_DEPOSIT_WALLETS_FAILED,
  FETCH_DEPOSIT_WALLETS_START,
  FETCH_DEPOSIT_WALLETS_SUCCESS,
  FETCH_DEPOSITS_FAILED,
  FETCH_DEPOSITS_START,
  FETCH_DEPOSITS_SUCCESS,
  FETCH_WITHDRAWALS_FAILED,
  FETCH_WITHDRAWALS_START,
  FETCH_WITHDRAWALS_SUCCESS,
  // FETCH_WALLET_REPORT_FAILED,
  // FETCH_WALLET_REPORT_START,
  // FETCH_WALLET_REPORT_SUCCESS,
  // REQUEST_WALLET_FX_TRANSFER_ERROR,
  // REQUEST_WALLET_FX_TRANSFER_START,
  // REQUEST_WALLET_FX_TRANSFER_SUCCESS,
} from './actionTypes'

const initialState = {
  loading: false,
  depositWallets: [],
  wallets: [],
  allWallets: {}, // it has all type ['total','trading', 'funding', 'margin', 'futures' ]
  transferLoading: false,
  clearingCounter: 0,
  report: {
    loading: false,
    data: [],
    pagination: {},
  },
  transactions: {
    loadingDeposit: false,
    loadingWithdraw: false,
    data: [],
  },
}

const htxReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DEPOSIT_WALLETS_START:
      state = {
        ...state,
        loading: true,
      }
      break
    case FETCH_DEPOSIT_WALLETS_FAILED:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      }
      break

    case FETCH_DEPOSIT_WALLETS_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: '',
        depositWallets: action.payload,
      }
      break

    // case REQUEST_WALLET_FX_TRANSFER_START:
    //   state = {
    //     ...state,
    //     transferLoading: true,
    //   }
    //   break
    // case REQUEST_WALLET_FX_TRANSFER_SUCCESS:
    //   state = {
    //     ...state,
    //     transferLoading: false,
    //     clearingCounter: state.clearingCounter + 1,
    //   }
    //   break
    // case REQUEST_WALLET_FX_TRANSFER_ERROR:
    //   state = {
    //     ...state,
    //     transferLoading: false,
    //   }
    //   break
    // case FETCH_WALLET_REPORT_START:
    //   state = {
    //     ...state,
    //     report: {
    //       ...state.report,
    //       loading: true,
    //     },
    //   }
    //   break
    // case FETCH_WALLET_REPORT_SUCCESS:
    //   state = {
    //     ...state,
    //     report: {
    //       ...state.report,
    //       loading: false,
    //       data: action.payload.docs,
    //       pagination: {
    //         ...action.payload,
    //       },
    //     },
    //   }
    //   delete state.report.pagination.docs
    //   break
    // case FETCH_WALLET_REPORT_FAILED:
    //   state = {
    //     ...state,
    //     report: {
    //       ...state.report,
    //       loading: false,
    //     },
    //   }
    //   break
        case FETCH_DEPOSITS_START: 
      state = {
        ...state,
        transactions: { 
          ...state.transactions,
          loadingDeposit: true,
        }
      };
    break;
    case FETCH_DEPOSITS_SUCCESS:
      console.log("HTX FETCH TRANSACTIONS DEPOSIT:", action.payload); // Debug log
      state = {
        ...state,
        transactions: { 
          ...state.transactions,
          loadingDeposit: false,
          data: [...state.transactions.data, ...action.payload.result.data.map((item) => ({ ...item, type: "DEPOSIT" })  )],
        }
      };
    break;
    case FETCH_DEPOSITS_FAILED:
      state = {
        ...state,
        transactions: { 
          ...state.transactions,
          loadingDeposit: false,
        }
      };
    break;
    case FETCH_WITHDRAWALS_START: 
    console.log("HTX FETCH TRANSACTIONS WITHDRAWAL:", action.payload)
      state = {
        ...state,
        transactions: { 
          ...state.transactions,
          loadingWithdraw: true,
        }
      };
    break;
    case FETCH_WITHDRAWALS_SUCCESS: 
      state = {
        ...state,
        transactions: { 
          ...state.transactions,
          loadingWithdraw: false,
          data: [...state.transactions.data, ...action.payload.result.data.map((item) => ({ ...item, type: "WITHDRAW" }))],
        }
      };
    break;
    case FETCH_WITHDRAWALS_FAILED:
      state = {
        ...state,
        transactions: { 
          ...state.transactions,
          loadingWithdraw: false,
        }
      };
    break;
    default:
      state = { ...state }
      break
  }
  return state
}

export default htxReducer
